import { deepValue } from '@corratech/pylot-utils'
import { CartItemInterface, ProductInterface } from '@pylot-data/pylotschema'
import { getCategoryName } from './getCategoryName'

export const getItemCategoryName = (
    data: ProductInterface | CartItemInterface
): string => {
    const categories =
        deepValue(data, ['categories']) ??
        deepValue(data, ['product', 'categories']) ??
        []

    if (!Array.isArray(categories)) {
        return ''
    }

    const rootCategories = categories.filter((c) => c?.breadcrumbs == null)

    if (rootCategories.length > 0) {
        return rootCategories[rootCategories.length - 1]?.name ?? ''
    }

    return getCategoryName(data as ProductInterface)
}
